// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2026-07-29
// Modified By: Jonathon Hicke
//
// Copyright 2025 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./RunningStatusControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";
import { CONTROLLER_WORLDWIDE_SOFT_START } from "src/constants/miscellaneous";

// Container for all running status controls for the Running Status section of the Remote Operation Panel.
export default function RunningStatusControls(props: Props): Component {
  return (
    <PanelSection label="Running Status">
      {props.controllerModel !== CONTROLLER_WORLDWIDE_SOFT_START && (
        <div className={`col px-3 ${styles.controlColumn}`}>
          <button
            data-test="running-status-on-button"
            className="btn btn-success w-100"
            type="button"
            disabled={props.disabled}
            onClick={() => props.onChangeRunningStatus("ON")}
          >
            ON
          </button>
        </div>
      )}
      <div className={`col px-3 ${styles.controlColumn}`}>
        <button
          data-test="running-status-off-button"
          className="btn btn-danger w-100"
          type="button"
          disabled={props.disabled}
          onClick={() => props.onChangeRunningStatus("OFF")}
        >
          OFF
        </button>
      </div>
    </PanelSection>
  );
}

interface Props {
  controllerModel: string;
  disabled: boolean;
  onChangeRunningStatus: (runningStatus: string) => void;
}
